module.exports = __webpack_public_path__ + "static/media/sticker_white.d01cb632.png";